import { jsx as _jsx } from "react/jsx-runtime";
import { $t } from '../../../../../../hooks/useTranslation';
import { CREATE_EXPENSE_REPORT_OPTIONS } from '../../../../../../views/CreateExpenseReport/utils/constants';
import { OptionCardStyled } from '../../../../../../views/CreateExpenseReport/utils/styles';
import BlankReportForm from './BlankReportForm';
import SelectDateRangeForm from './SelectDateRangeForm';
import CreditCardTransactionsForm from './CreditCardTransactionsForm';
const { ALL_ITEMS, CREDIT_CARD_TRANSACTIONS, DATE_RANGE, BLANK } = CREATE_EXPENSE_REPORT_OPTIONS;
function CreateExpenseReportOptionsCard({ option, selectedOptionValue, disabled = false }) {
    const { value, iconUrl, label } = option;
    let FormComponent = null;
    // The initial value not being set will give us the "Blank"/default form
    const defaultBlankReportForm = (_jsx(BlankReportForm, { value: value, iconUrl: iconUrl, labelText: $t(label), disabled: disabled }));
    if (selectedOptionValue !== value) {
        FormComponent = defaultBlankReportForm;
    }
    else {
        switch (value) {
            case ALL_ITEMS:
                FormComponent = defaultBlankReportForm;
                break;
            case CREDIT_CARD_TRANSACTIONS:
                FormComponent = (_jsx(CreditCardTransactionsForm, { value: value, iconUrl: iconUrl, titleLabelText: $t(label), startDateLabelText: $t('Start Date'), endDateLabelText: $t('End Date') }));
                break;
            case DATE_RANGE:
                FormComponent = (_jsx(SelectDateRangeForm, { value: value, iconUrl: iconUrl, titleLabelText: $t(label), startDateLabelText: $t('Start Date'), endDateLabelText: $t('End Date') }));
                break;
            case BLANK:
            default:
                FormComponent = defaultBlankReportForm;
                break;
        }
    }
    return _jsx(OptionCardStyled, { children: FormComponent });
}
export default CreateExpenseReportOptionsCard;
